import api from '../core/api';

export interface SettingKeyDef {
  key: string;
  label: string;
  description: string;
  type: string;
  defaultValue?: string;
  options?: { value: string; label: string }[];
  isEncrypted?: boolean;
  accept?: string;
}

export interface SettingCategoryDef {
  key: string;
  label: string;
  description: string;
  icon: string;
  keys: SettingKeyDef[];
}

export interface SettingRow {
  _id: string | null;
  category: string;
  key: string;
  value: string;
  description?: string;
  isEncrypted?: boolean;
  hasValue?: boolean;
}

export async function getSettingsCatalog() {
  const res = await api.get('/admin/settings/catalog');
  return res.data.data as SettingCategoryDef[];
}

export async function getSettings(category?: string) {
  const res = await api.get('/admin/settings', { params: category ? { category } : {} });
  return res.data.data as SettingRow[];
}

export async function upsertSetting(payload: { category: string; key: string; value: string; isEncrypted?: boolean }) {
  const res = await api.put('/admin/settings', payload);
  return res.data.data;
}

export async function bulkUpsertSettings(settings: { category: string; key: string; value: string }[]) {
  const res = await api.put('/admin/settings/bulk', { settings });
  return res.data.data;
}

export async function uploadSettingFile(
  file: File,
  category: string,
  key: string,
): Promise<{ url: string; storage: 'local' | 's3'; fileName: string }> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('category', category);
  formData.append('key', key);
  const res = await api.post('/admin/settings/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data.data;
}
